/**
 * Directive can create the columns for the grid semi-dynamically. Caveat! This
 * can only be done during initialisation phase of the grid. You can't change
 * the columns after the grid is build up.
 * but if you rerender the component everything can be reinitialized.
 * if this feature is required for FarmNet please contact ASG arne@aplaypowered.com to get information on using it.
 */
angular.module('cfn').directive('cfnDynamicColum', [
  '$rootScope',
  'i18nFilter',
  function($rootScope, i18nFilter) {
    return {
      require: '^cfnGridNew',
      restrict: 'E',
      scope: {
        configuration: '=configuration'
      },
      link: function($scope, element, attrs, cfnGridController) {
        $scope.$rootScope = $rootScope;

        Object.keys($scope.configuration).forEach(function(key) {
          $scope[key] = $scope.configuration[key];
        });
        if ($scope.title && $scope.title.indexOf('fe.') != -1) {
          $scope.title = i18nFilter($scope.title);
        }

        $scope.renderer = function() {};
        $scope.onchange = function() {};
        $scope.aggregateFn = function() {};

        cfnGridController._addColumn($scope);

        $scope.setAggregateType = function(value) {
          $scope.aggregateType = value;
        };
      }
    };
  }
]);
